export default "__VITE_ASSET__D$3ej2aW__"